<template>
  <div class="referral-controls-container">
    <h4 class="title">{{$t('referral.controls.title')}}</h4>

    <div class="row start">
      <invite-by-social></invite-by-social>
    </div>
    <login-method-separator :text="$t('or')" class="separator" />
    <div class="row">
      <invite-link></invite-link>
    </div>
    <login-method-separator :text="$t('or')" class="separator" />
    <div class="row">
      <invite-by-emails></invite-by-emails>
    </div>
    <login-method-separator :text="$t('or')" class="separator" />
    <div class="row end">
      <invite-by-gmail></invite-by-gmail>
    </div>
  </div>
</template>

<script>
import LoginMethodSeparator from '@/components/login/LoginMethodSeparator.vue';
import InviteByEmails from './InviteByEmails.vue';
import InviteLink from './InviteLink.vue';
import InviteBySocial from './InviteBySocial.vue';
import InviteByGmail from './InviteByGmail.vue';

export default {
  components: {
    InviteByEmails,
    InviteLink,
    InviteBySocial,
    InviteByGmail,
    LoginMethodSeparator,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.referral-controls-container {
  box-shadow: 0 0 10px 0.05px $shadow;
  padding: 20px 88px;
  width: 60vw;
  min-width: 800px;
}

.title {
  font-size: 24px;
  text-align: center;
}

.row {
  margin: 30px 0;
  display: flex;
  width: 100%;
  justify-content: center;
}

.start {
  align-items: flex-start;
}

.end {
  align-items: flex-end;
}

.separator {
  color: black;
}
</style>
